import { useDispatch, useSelector } from 'react-redux';
import { Alert, Col, Container, Form, Row } from 'react-bootstrap';
import withLayout from '../../components/Layout/withLayout';
import {
  opcoList,
  optionMapper,
  optionValueMapper,
} from '../../components/constant';
import { StyledButton } from '../../StyledComponets';
import ProjectListGrid from './ProjectList';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { initialValues, nonFieldOption, PRJ_KEY, ValidationSchema } from './helpers';
import {
  fetchProjectsData,
  resetSearchDataReducer,
  setPageParams,
  setSearchParams,
} from '../../app/projects/searchProjectSlice';
import { projectsGridConfig } from './config';
import { useEffect, useState } from 'react';
import {
  fetchStatusListData,
  getProjectStatuses,
} from '../../app/projects/statusListSlice';
import ProjectUpdate from './projectViewUpdate';

export function ProjectView(props) {
  const {
    register,
    watch,
    handleSubmit,
    trigger,
    setValue,
    getValues,
    reset,
    clearErrors,
    formState: { errors, isValid, isValidating },
  } = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
    resolver: yupResolver(ValidationSchema),
    defaultValues: initialValues,
  });
  const dispatch = useDispatch();
  const statusList = useSelector(getProjectStatuses);
  const [showProjectView, setShowProjectView] = useState({ show: false });

  const renderError = (key) =>
    errors?.[key]?.message && (
      <Form.Control.Feedback type="invalid">
        {errors?.[key]?.message}
      </Form.Control.Feedback>
    );

  const onSearch = (extObj) => { 
      if (getValues(PRJ_KEY.PRJ_ID)) {
        setValue(PRJ_KEY.OPCO, '');
        setValue(PRJ_KEY.STATUS, '');
      }
      const reqObj = {
        searchKey:extObj?.searchKey || getValues(PRJ_KEY.SRCH_BY),
        idVal: extObj?.idVal || getValues(PRJ_KEY.PRJ_ID),
        opco: getValues(PRJ_KEY.OPCO),
        status: getValues(PRJ_KEY.STATUS),
        appType: getValues(PRJ_KEY.APP_TYPE)
      };
      dispatch(setSearchParams(reqObj));
      dispatch(setPageParams({ page: 1, pageSize: projectsGridConfig.pageSize }));
      dispatch(fetchProjectsData(reqObj));   
  };

  useEffect(() => {
    if (props.reqData?.idVal){
      onSearch(props.reqData)
    }
    if (!statusList?.edw_status?.length && !props.reqData) {
      dispatch(fetchStatusListData({ opco: '' }));
    }
  }, []);

  

  const searchByField = register(PRJ_KEY.SRCH_BY);
  const opcoField = register(PRJ_KEY.OPCO);

  const onOpcoChange = (e) => {
    // dispatch(fetchStatusListData({ opco: e.target.value }));
    // if (e.target.value) {
    //   setValue(PRJ_KEY.STATUS, '');
    // }
    opcoField.onChange(e);
  };

  const onSearchByChange = (e) => {
    if (e.target.value) {
      setValue(PRJ_KEY.PRJ_ID, '');
      setValue(PRJ_KEY.OPCO, '');
      setValue(PRJ_KEY.STATUS, '');
      clearErrors();
      dispatch(resetSearchDataReducer());
    }
    searchByField.onChange(e);
  };

  const searchOptionList = [
    'Application Number',
    'Application Type',
    'Project Number',
    'Premises Number',
    'Account Number',
    'EZ Id',
    'Meter Number',
    'Opco & Status',
  ];


  const charLengthObj = {
    'Project Number': 12,
    'Premises Number': 9,
    'Account Number': 10,
    'EZ Id': 17,
    'Meter Number': 9,
  };

  return (
    <>
      <br />
      <div style={{ display: `${showProjectView.show ? 'none' : 'block'}` }}>
        {!props.hideForm &&<Form noValidate onSubmit={handleSubmit(onSearch)}>
          <Row>
            <Col>
              <Form.Text size="sm" style={{ margin: '2px' }}>
                Search By
              </Form.Text>
              <Form.Select
                size="sm"
                aria-label="searchBy"
                {...searchByField}
                onChange={onSearchByChange}
              >
                {optionMapper(searchOptionList)}
              </Form.Select>
            </Col>
            {!nonFieldOption.includes(getValues(PRJ_KEY.SRCH_BY)) && (
              <Col>
                <Form.Text size="sm" style={{ margin: '2px' }}>
                  {getValues(PRJ_KEY.SRCH_BY)}
                </Form.Text>
                <Form.Control
                  type="text"
                  {...register(PRJ_KEY.PRJ_ID)}
                  placeholder={getValues(PRJ_KEY.SRCH_BY)}
                  maxLength={charLengthObj[getValues(PRJ_KEY.SRCH_BY)]}
                  isInvalid={errors[PRJ_KEY.PRJ_ID]}
                />
                {renderError(PRJ_KEY.PRJ_ID)}
              </Col>
            )}
            {getValues(PRJ_KEY.SRCH_BY) === 'Opco & Status' && (
              <>
                <Col>
                  <Form.Text size="sm" style={{ margin: '2px' }}>
                    Operating Company
                  </Form.Text>
                  <Form.Select
                    size="sm"
                    aria-label="opco"
                    {...opcoField}
                    onChange={onOpcoChange}
                    isInvalid={errors[PRJ_KEY.OPCO]}
                  >
                    <option value="">Please select</option>
                    {optionValueMapper(opcoList)}
                  </Form.Select>
                  {renderError(PRJ_KEY.OPCO)}
                </Col>
                <Col>
                  <Form.Text size="sm" style={{ margin: '2px' }}>
                    Status
                  </Form.Text>
                  <Form.Select
                    size="sm"
                    aria-label="status"
                    {...register(PRJ_KEY.STATUS)}
                    isInvalid={errors[PRJ_KEY.STATUS]}
                  >
                    <option value="">Please select</option>
                    {optionMapper(
                      statusList?.edw_status?.length
                        ? statusList?.edw_status
                        : statusList?.length
                        ? statusList
                        : []
                    )}
                  </Form.Select>
                  {renderError(PRJ_KEY.STATUS)}
                </Col>
              </>
            )}
            {getValues(PRJ_KEY.SRCH_BY) === 'Application Type' && (
              <>
                <Col>
                  <Form.Text size="sm" style={{ margin: '2px' }}>
                    Application Type
                  </Form.Text>
                  <Form.Select
                    size="sm"
                    aria-label="appType"
                    {...register(PRJ_KEY.APP_TYPE)}
                    isInvalid={errors[PRJ_KEY.APP_TYPE]}
                  >
                    <option value="">Please select</option>
                    {optionMapper(
                      ['Interconnect','PreApplication']
                    )}
                  </Form.Select>
                  {renderError(PRJ_KEY.APP_TYPE)}
                </Col>
                <Col>
                  <Form.Text size="sm" style={{ margin: '2px' }}>
                    Operating Company (optional)
                  </Form.Text>
                  <Form.Select
                    size="sm"
                    aria-label="opco"
                    {...opcoField}
                    onChange={onOpcoChange}
                    isInvalid={errors[PRJ_KEY.OPCO]}
                  >
                    <option value="">Please select</option>
                    {optionValueMapper(opcoList)}
                  </Form.Select>
                  {renderError(PRJ_KEY.OPCO)}
                </Col>             
              </>
            )}
          </Row>
          <StyledButton
            type="submit"
            btnType="primary"
            variant="dark"
            size="md"
          >
            Search
          </StyledButton>
        </Form>}
        <Container aria-label="list-grid-container" fluid>
          <ProjectListGrid
            searchParams={{
              searchKey:props.reqData?.searchKey || getValues(PRJ_KEY.SRCH_BY),
              idVal: props.reqData?.idVal || getValues(PRJ_KEY.PRJ_ID),
              opco: getValues(PRJ_KEY.OPCO),
              status: getValues(PRJ_KEY.STATUS),
              appType: getValues(PRJ_KEY.APP_TYPE)
            }}
            showProjectView={showProjectView}
            isEnrollmentView={Boolean(props.reqData?.idVal)}
            setShowProjectView={setShowProjectView}
          />
        </Container>
      </div>
      {showProjectView.show && (
        <ProjectUpdate
          projectViewSt={showProjectView}
          setShowProjectView={setShowProjectView}
        />
      )}
    </>
  );
}

export default withLayout(ProjectView);
